export default __webpack_public_path__ + "static/media/powell_cat_likes.1aa57a54.png";